<template>
  <div class="content-box">
    <el-row class="row-col-style" :gutter="20">
      <el-col :span="6" class="row-col-style">
        <el-card class="card-box">
          <div class="title-box">
            <span class="enterprise-title">企业列表 : </span>
            <el-input v-model="enterpriseData" clearable style="width: 70%;vertical-align: middle" size="mini"
                      placeholder="请输入">
              <el-button @click="searchEnterprise" slot="append" icon="el-icon-search"></el-button>
            </el-input>
          </div>
          <div class="item-box">
            <el-tree v-loading="treeLoadingType" :data="AreaData" :props="defaultProps"
                     @node-click="handleNodeClick"></el-tree>
          </div>
        </el-card>
      </el-col>
      <el-col :span="18" class="row-col-style">
        <el-card class="box-card">
          <el-form :inline="true" :model="formInline" class="demo-form-inline">
            <el-form-item label="登录账号 : ">
              <el-input v-model="formInline.account" clearable size="mini" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="姓名 : ">
              <el-input v-model="formInline.username" clearable size="mini" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button @click="searchTableData(1)" type="primary" size="mini">查询</el-button>
              <el-button @click="searchTableData(2)" size="mini">重置</el-button>
            </el-form-item>
          </el-form>
          <div style="margin-bottom: 20px">
            <el-button @click="openDrawer(1, {})" size="mini">新增</el-button>
            <el-button :loading="enableType" @click="enableOrDisable(0)" size="mini">启用</el-button>
            <el-button :loading="disableType" @click="enableOrDisable(1)" size="mini">禁用</el-button>
            <el-popconfirm
                style="padding: 10px"
                title="确定将密码重置为账号？"
                @confirm="passwordReset"
            >
              <el-button :loading="passwordType" size="mini" slot="reference">密码重置</el-button>
            </el-popconfirm>
          </div>
          <el-table
              row-key="id"
              v-loading="tableLoadingType"
              class="tableListValue"
              :height="tableHeight"
              ref="table"
              :data="tableData"
              stripe
              style="width: 100%">
            <el-table-column
                :reserve-selection="true"
                align="center"
                type="selection"
                width="50">
            </el-table-column>
            <el-table-column
                align="center"
                prop="account"
                label="登录账号">
            </el-table-column>
            <el-table-column
                align="center"
                prop="username"
                label="姓名">
            </el-table-column>
            <el-table-column
                align="center"
                prop="phone"
                label="联系方式">
            </el-table-column>
            <el-table-column
                align="center"
                prop="enable"
                label="状态">
              <template slot-scope="scope">
                <el-tag :type="scope.row.enable===0? 'success':'danger'">{{ enableObj[scope.row.enable] }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column
                align="center"
                prop="roleName"
                label="所属角色">
            </el-table-column>
            <el-table-column
                align="center"
                prop="orgName"
                label="所属企业">
            </el-table-column>
            <el-table-column
                align="center"
                prop="createTime"
                label="创建时间">
            </el-table-column>
            <el-table-column
                prop="address"
                align="center"
                width="120"
                label="操作">
              <template slot-scope="scope">
                <el-link @click="openDrawer(2, scope.row)" type="primary" :underline="false"
                         style="padding-right: 10px">编辑
                </el-link>
                <el-popconfirm
                    title="确定删除该账号？"
                    @confirm="deleteItem(scope.row)"
                >
                  <el-link slot="reference" type="danger" :underline="false">
                    <i v-if="scope.row.deleteType" class="el-icon-loading"></i>
                    删除
                  </el-link>
                </el-popconfirm>
              </template>
            </el-table-column>
          </el-table>
          <div class="pagination">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[10, 20, 30, 40]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total">
            </el-pagination>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <!--    新增修改弹框-->
    <el-drawer
        :destroy-on-close="true"
        :show-close="false"
        :title="drawerTitle"
        :visible.sync="drawerType"
        direction="rtl"
        size="30%">
      <account-dialog :drawerForm="drawerForm" :dialogType="dialogType" @drawerClose="drawerClose"></account-dialog>
    </el-drawer>
  </div>
</template>

<script>
import {getAreaTree} from "../../common/enterpriseApi";
import {getUserList, updateUsers, resetPasspord, delUser, getUserDataEcho} from "../../common/accountApi";
import AccountDialog from './components/accountDialog'

export default {
  name: "account",
  components: {
    AccountDialog
  },
  data() {
    return {
      enableObj: {
        0: '启用',
        1: '禁用'
      },
      enterpriseData: '',
      drawerForm: {},
      drawerTitle: '新增账号',
      drawerType: false,
      passwordType: false,
      enableType: false,
      disableType: false,
      tableLoadingType: false,
      treeLoadingType: false,
      currentPage: 1,
      dialogType: 0,
      pageSize: 10,
      total: 0,
      formInline: {},
      tableHeight: 0,
      tableData: [],
      AreaData: [],
      defaultProps: {
        children: 'menuChildren',
        label: 'orgName'
      }
    }
  },
  mounted() {
    this.$nextTick(function () {
      this.tableHeight =
          window.innerHeight - this.$refs.table.$el.offsetTop - 175
    })
    this.getAreaTree()
    this.getUserList()
  },
  methods: {
    // 删除账号
    async deleteItem(item) {
      this.$set(item, 'deleteType', true)
      try {
        const res = await delUser({id: item.id})
        if (res.code === 200) {
          this.$notify.success({
            title: '成功提示',
            message: '账号删除成功'
          })
          this.getUserList()
        } else {
          this.$notify.error({
            title: '错误提示',
            message: res.msg
          })
          this.$set(item, 'deleteType', false)
        }
      } catch (e) {
        this.$set(item, 'deleteType', false)
        console.log(e)
      }
    },
    // 弹框关闭
    drawerClose() {
      this.getUserList()
      this.$refs.table.clearSelection();
      this.drawerType = false
    },
    // 重置密码
    async passwordReset() {
      const arr = this.$refs.table.selection;
      if (arr.length === 0) {
        this.$notify.error({
          title: '操作错误 !',
          message: '请选择数据后操作 !'
        })
        return
      }
      if (arr.length > 1) {
        this.$notify.error({
          title: '操作错误 !',
          message: '只可选择一条数据后操作 !'
        })
        return
      }
      try {
        this.passwordType = true
        const res = await resetPasspord({id: arr[0].id})
        if (res.code === 200) {
          this.$notify.success({
            title: '成功提示',
            message: '密码重置成功'
          })
          this.$refs.table.clearSelection();
          this.passwordType = false
          this.getUserList()
        } else {
          this.$notify.error({
            title: '错误提示',
            message: res.msg
          })
          this.passwordType = false
        }
      } catch (e) {
        this.passwordType = false
        console.log(e)
      }
    },
    // 启用禁用
    async enableOrDisable(type) {
      const arr = this.$refs.table.selection;
      if (arr.length === 0) {
        this.$notify.error({
          title: '操作错误 !',
          message: '请选择数据后操作 !'
        })
        return
      }
      try {
        if (type === 0) {
          this.enableType = true
        } else {
          this.disableType = true
        }
        const idsArr = []
        for (const el of arr.values()) {
          idsArr.push(el.id)
        }
        const param = {
          ids: idsArr,
          enable: type
        }
        const res = await updateUsers(param)
        if (res.code === 200) {
          this.$notify.success({
            title: '成功提示',
            message: type === 0 ? '账号启用成功' : '账号禁用成功'
          })
          this.enableType = false
          this.disableType = false
          this.$refs.table.clearSelection();
          this.getUserList()
        } else {
          this.$notify.error({
            title: '错误提示',
            message: res.msg
          })
          this.enableType = false
          this.disableType = false
        }
        this.$refs.table.clearSelection();
      } catch (e) {
        this.enableType = false
        this.disableType = false
        console.log(e)
      }
    },
    // 打开新增/修改弹框
    async openDrawer(type, item) {
      this.dialogType = type
      if (type === 1) {
        this.drawerForm = {}
        this.drawerTitle = '新增账号'
      } else {
        const res = await getUserDataEcho({id: item.id})
        if (res.code === 200) {
          this.drawerForm = res.data
          this.drawerForm.parentCodes = this.drawerForm.parentCodes.reverse()
        } else {
          this.$notify.error({
            title: '错误提示',
            message: res.msg
          })
        }
        this.drawerTitle = '修改账号'
      }
      this.drawerType = true
    },
    // 获取企业列表
    async getAreaTree() {
      this.treeLoadingType = true
      try {
        const res = await getAreaTree({orgName: this.enterpriseData})
        if (res.code === 200) {
          this.AreaData = res.data
          this.treeLoadingType = false
        } else {
          this.treeLoadingType = false
          this.$notify.error({
            title: '错误提示',
            message: res.msg
          })
        }
      } catch (e) {
        this.treeLoadingType = false
        console.log(e)
      }
    },
    // 获取账号列表
    async getUserList() {
      this.tableLoadingType = true
      try {
        const param = {
          account: this.formInline.account,
          orgCode: this.formInline.orgCode,
          username: this.formInline.username,
          pageNo: this.currentPage,
          pageSize: this.pageSize
        }
        const res = await getUserList(param)
        if (res.code === 200) {
          this.tableData = res.data
          for (const el of this.tableData.values()) {
            this.$set(el, 'deleteType', false)
          }
          this.total = res.total
          this.tableLoadingType = false
        } else {
          this.tableLoadingType = false
          this.$notify.error({
            title: '错误提示',
            message: res.msg
          });
        }
      } catch (e) {
        this.tableLoadingType = false
      }
    },
    // 搜索重置
    searchTableData(type) {
      if (type === 2) {
        this.formInline = {}
      }
      this.getUserList()
    },
    // 搜索企业
    searchEnterprise() {
      this.getAreaTree()
    },
    // 树状结构点击
    handleNodeClick(data) {
      this.formInline.orgCode = data.orgCode
      this.getUserList()
    },
    handleSizeChange(e) {
      this.pageSize = e
      this.getUserList()
    },
    handleCurrentChange(e) {
      this.currentPage = e
      this.getUserList()
    },
  }
}
</script>

<style scoped>
.content-box /deep/ .el-card__body {
  height: 100% !important;
}

.content-box /deep/ .el-loading-spinner {
  margin-top: 0 !important;
}

.item-box {
  height: calc(100% - 100px);
  overflow-y: auto;
}

.enterprise-title {
  font-size: 14px;
  color: #606266;
}

.title-box {
  margin-bottom: 20px;
}

.card-box {
  height: 100%;
  text-align: left;
  border-radius: 10px;
}

.row-col-style {
  height: 100% !important;
}

.pagination {
  margin-top: 10px;
  text-align: right;
}

.box-card {
  text-align: left;
  border-radius: 10px;
  height: 100%;
}
</style>
<style scoped lang="scss">
.tableListValue {
  //滚动条的宽高
  ::-webkit-scrollbar {
    width: 1vh;
    height: 1vh;
  }

  //滚动条的滑块背景色
  ::-webkit-scrollbar-thumb {
    background: #ccc;
    border-radius: 2vh;
  }

  //滚动条的背景色
  ::-webkit-scrollbar-track {
    background: rgba(#ccc, 0.3);
  }

}


/* 设置滚动条的样式 */
/*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/

::-webkit-scrollbar {
  width: 10px;
  height: 8px;
}


/*定义滚动条轨道 内阴影+圆角*/

::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  background-color: #F5F5F5;
}


/*定义滑块 内阴影+圆角*/

::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(255, 255, 255, 0.1);
  background-color: #ccc;

}

</style>
